export function createDynamicPricingClient(transport) {
    return {
        /**
         * Read the latest tenant policy
         *
         * Requires scope: dynamic-pricing:read
         */
        getDynamicPricingPolicies(policyId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/dynamic-pricing/policies/${encodeURIComponent(policyId)}`,
                options,
            });
        },
        /**
         * Create an immutable policy version
         *
         * Requires scope: dynamic-pricing:write
         */
        putDynamicPricingPolicies(policyId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/dynamic-pricing/policies/${encodeURIComponent(policyId)}`,
                body,
                options,
            });
        },
        /**
         * Compute a bounded integer basis-point supply-demand adjustment
         *
         * Requires scope: dynamic-pricing:evaluate
         */
        postDynamicPricingPoliciesEvaluate(policyId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/dynamic-pricing/policies/${encodeURIComponent(policyId)}/evaluate`,
                body,
                options,
            });
        },
        /**
         * Every manual surge override this tenant has raised, newest first
         *
         * Requires scope: dynamic-pricing:read
         */
        listSurgeOverrides(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/dynamic-pricing/zone-overrides",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Raise a manual surge override on one zone
         *
         * Requires scope: dynamic-pricing:write
         */
        raiseSurgeOverride(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/dynamic-pricing/zone-overrides",
                body,
                options,
            });
        },
        /**
         * End a manual surge override before its own expiry
         *
         * Requires scope: dynamic-pricing:write
         */
        endSurgeOverride(overrideId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/dynamic-pricing/zone-overrides/${encodeURIComponent(overrideId)}/end`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=dynamic-pricing.js.map